import { useState } from 'react';
import { toast } from 'sonner';
import { getAuthToken } from '@/utils/auth';

interface DeleteResponse {
  success: boolean;
  error?: string;
}

export const useDeleteProfessionalDocument = (doctorId: string) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const deleteDocument = async (): Promise<boolean> => {
    setIsLoading(true);
    setError(null);

    try {
      const token = getAuthToken();
      
      if (!token) {
        throw new Error('Token de autenticação não encontrado. Faça login novamente.');
      }

      const response = await fetch(
        `${import.meta.env.VITE_API_BASE_URL}/doctors/${doctorId}/professional-documents`,
        {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        }
      );

      const data: DeleteResponse = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.error || 'Erro ao deletar documento');
      }

      toast.success('✓ Documento deletado com sucesso!');
      setIsLoading(false);
      return true;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Erro desconhecido';
      setError(errorMessage);
      toast.error(errorMessage);
      setIsLoading(false);
      return false;
    }
  };

  return { deleteDocument, isLoading, error };
};
